/**
 * Pre-compiled en messages for NumberInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { decrement: `Decrement`, increment: `Increment` };
